import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import { RASTER_LANDINGS, SVG_LANDINGS } from "@ryde/assets-landings";
import { normalizePhoneNumber } from "@ryde/shared";
import {
  LANDING_RYDE_SUPPORT_PHONE,
  landingColors,
} from "@ryde/utils-landings";

import { DownloadsAppButtons } from "../../widgets";

export const StepFinishedNvidiaShuttle: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <SVG_LANDINGS.GreenSVG
        color={landingColors.mintGreen}
        className="v-green-icon"
        aria-hidden="true"
      />
      <h1
        className="landing-title font-size-30"
        style={{ color: landingColors.mintGreen }}
      >
        {t("landing.finished.title1")}
      </h1>
      <p
        className="landing-title font-size-30"
        style={{ color: landingColors.label }}
      >
        {t("landing.finished.title2")}
      </p>

      <div className="divider-bar-label" aria-hidden="true" />

      <div
        className="landing-sub-title font-size-18"
        style={{ color: landingColors.label }}
      >
        {t("landing.finished.smsInstructionSent")}
      </div>
      <div
        className="landing-sub-title font-size-18"
        style={{ color: landingColors.label }}
      >
        {t("landing.finished.downloadAppSuggestion")}
      </div>

      <div className="divider-bar margin-top-4" aria-hidden="true" />

      <DownloadsAppButtons />

      <div className="landing-container-footer">
        <div className="landing-container-footer-logo">
          <img
            className="landing-logo__img"
            src={RASTER_LANDINGS.RideLogoPNG}
            alt="Ryde logo"
            width="120"
            height="51"
          />
        </div>

        <p className="landing-customer-support">
          <Trans
            i18nKey="landing.helpDisclaimer"
            values={{
              phoneNumber: normalizePhoneNumber(LANDING_RYDE_SUPPORT_PHONE),
            }}
            components={{
              secure_link: (
                <a
                  aria-label="call center phone number"
                  href={`tel:${LANDING_RYDE_SUPPORT_PHONE}`}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              br: <br />,
            }}
          />
        </p>
      </div>
    </>
  );
};
